import { Injectable } from '@angular/core';
import { UrlTree, CanActivate, Router } from '@angular/router';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { filter, Observable, of, switchMap } from 'rxjs';

import { UserTier } from '../enum/user-tier';
import { UserStoreService } from '../store/user-store.service';
import { isNonNull } from './redeem-blocked.guard';

@Injectable({
  providedIn: 'root',
})
export class TierAllowedGuard implements CanActivate {
  constructor(private router: Router, private userStore: UserStoreService, private authStore: AuthStoreService) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authStore.isRegularUser$.pipe(
      filter(isNonNull),
      switchMap((isRegularUser: boolean) => {
        if (isRegularUser) {
          if (this.authStore.userSettings?.country.alpha2Code === 'IN') {
            const user = this.authStore.userSettings?.user as any;

            const isIsgAuthorizedOrSilver =
              user.lenovoUserProfile?.dcgBpLevel === UserTier.AUTHORIZED ||
              user.lenovoUserProfile?.dcgBpLevel === UserTier.SILVER;

            const isIdgAuthorizedOrSilver =
              user.lenovoUserProfile?.pcsdBpLevel === UserTier.AUTHORIZED ||
              user.lenovoUserProfile?.pcsdBpLevel === UserTier.SILVER;

            if (isIsgAuthorizedOrSilver && isIdgAuthorizedOrSilver) {
              this.router.navigateByUrl('/gold-or-platinum-tier-allowed');
              return of(false);
            }
          }
        }

        return of(true);
      })
    );
  }
}
